/** Angular */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
/** Services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';
/** Models */
import { HomepageSixenseLatestProjects } from '../models/homepage-sixense-latest-projects.class';
import { HomepageProject } from '../models/homepage-project.class';
import { HomepageProjectLatestUsers } from '../models/homepage-project-latest-users.class';
import { HomepageProjectScopes } from '../models/homepage-project-scopes.class';
import { HomepageSixense } from '../models/homepage-sixense.class';

@Injectable({
  providedIn: 'root',
})
export class BydHomePageProjectService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService.
   */
  path: string;

  /**
   * Get the latest projects.
   *
   * @returns Observable<HomepageSixenseLatestProjects[]>
   */
  public getLatestProjects(): Observable<HomepageSixenseLatestProjects[]> {
    this.path = '/projects/latestprojects';
    return this.get();
  }

  /**
   * Get the latest projects.
   *
   * @returns Observable<HomepageSixenseLatestProjects[]>
   */
  public getUserInformations(): Observable<HomepageSixense[]> {
    this.path = '/projects/userinformations';
    return this.get();
  }

  /**
   * Get the latest projects.
   *
   * @param gid the project id
   * @returns Observable<HomepageProject[]>
   */
  public getInfoProject(gid: number): Observable<HomepageProject[]> {
    this.path = `/projects/${gid}/informations`;
    return this.get();
  }

  /**
   * Get the latest projects.
   *
   * @param gid the project id
   * @returns Observable<HomepageProjectLatestUsers[]>
   */
  public getLatestUsersLinksProject(gid: number): Observable<HomepageProjectLatestUsers[]> {
    this.path = `/projects/${gid}/latestusers`;
    return this.get();
  }

  /**
   * Get the latest projects.
   *
   * @param gid the project id
   * @returns Observable<HomepageProjectScopes[]>
   */
  public getScopeslinksProject(gid: number): Observable<[HomepageProjectScopes]> {
    this.path = `/projects/${gid}/scopes`;
    return this.get();
  }

  /**
   * Implement inherited abstract member 'createNewInstance' from BydRhsAbstractService.
   */
  public createNewInstance() {}
}
